<template>
  <FullScreenLoader></FullScreenLoader>
  <div v-if="starting">
  </div>
  <div class="wrapper" v-else-if="login != null">
    <aside class="main-sidebar sidebar-dark-primary elevation-4">
      <a href="/" class="brand-link">
        <span class="brand-text font-weight-light">Progibox Manager</span>
      </a>
      <div class="sidebar">
        <div class="user-panel mt-3 pb-3 mb-3 d-flex">
          <div class="info">
            <span v-if="role == 'super_administrator'" title="Super administrateur" class="text-yellow fas fa-crown"></span>&nbsp;<span class="text-gray" style="padding-right: 5px">{{ login }}</span><a @click="logout()"><span title="Se déconnecter" class="fas fa-sign-out-alt"></span></a>
          </div>
        </div>
        <nav>
          <ul class="nav nav-pills nav-sidebar flex-column">
            <li class="nav-item">
              <router-link :to="{name: 'Tenants'}">Tenants</router-link>
            </li>
            <li class="nav-item" v-if="role == 'super_administrator'">
              <router-link :to="{name: 'ProgiboxList'}">Progibox</router-link>
            </li>
            <li class="nav-item" v-if="role == 'super_administrator'">
              <router-link :to="{name: 'Realms'}">Utilisateurs</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
    <router-view></router-view>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>

import FullScreenLoader from "@/components/FullScreenLoader";
import {APIRequest} from "@/api-fetch";
import {useLoaderStore} from "@/stores/loader-store";
import {useGlobalStore} from "@/stores/global-store";
import {mapState} from "pinia";

export default {
  name: 'App',
  components: {FullScreenLoader},
  data() {
    return {
      starting: true
    }
  },
  computed: {
    ...mapState(useGlobalStore, ["login", "role"]),
  },
  mounted() {
    const loaderStore = useLoaderStore()
    APIRequest("GET", "/auth/connected")
        .then((resp) => {
          useGlobalStore().setLogin(resp.body.login)
          useGlobalStore().setRole(resp.body.role)
          this.starting = false
          loaderStore.hideFullScreenLoader()
        })
        .catch(() => {
          this.starting = false
          loaderStore.hideFullScreenLoader()
        })
  },
  methods: {
    logout() {
      this.starting = true
      useLoaderStore().showFullScreenLoader("Déconnexion en cours...")
      APIRequest("GET", "/auth/logout")
          .then(() => {
            useGlobalStore().setLogin(null)
            useGlobalStore().setConnected(false)
            useGlobalStore().setRole(null)
            location = "/login"
          })
    }
  }
}
</script>

<style>
</style>
